import { Controller, useFormContext } from 'react-hook-form';
import { MAX_FILES_AMOUNT } from '@features/config/files/files.config';
import { FileInput } from '@ui';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { memo } from 'react';
import { FormRow, CaseLinksBlock } from '@features/components/CaseFormBlocks/components';
import { FILE_TYPES } from '@features/components/CaseFormBlocks/config';

type CaseAttachmentsProps = {
  disabled?: boolean;
};

export const CaseAttachments = memo(({ disabled }: CaseAttachmentsProps) => {
  const { control } = useFormContext<CaseFormType>();

  return (
    <>
      <FormRow title="Attachments" multiRow>
        <Controller
          name="files"
          control={control}
          render={({ field: { value, onChange, ref, ...field }, fieldState: { invalid, error } }) => (
            <FileInput
              disabled={disabled}
              files={value}
              inputRef={ref}
              placeholder="Add Item"
              multiple
              maxFiles={MAX_FILES_AMOUNT}
              maxSize={500000000}
              showMaxSize
              accept={FILE_TYPES}
              isInvalid={invalid}
              errorMessage={error?.message}
              onFilesChange={(files) => {
                if (disabled) return;
                const fileList = new Set([...(value || []), ...files]);
                onChange(Array.from(fileList));
              }}
              onFileDelete={(file) => {
                if (disabled) return;
                const newFiles = value.filter((i) => file.id !== i.id);
                onChange(newFiles || []);
              }}
              {...field}
            />
          )}
        />
      </FormRow>
      <CaseLinksBlock disabled={disabled} />
    </>
  );
});
